import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { ManagedLoginService } from 'src/app/managed-login.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  authState: boolean = false;

  constructor(
    private authService: PermissionsService,
    private managedLoginService: ManagedLoginService
  ) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (this.authService.isAuthenticated()) {
      console.log('yessss');
      return true;
    } else {
      console.log('noooo');
      this.managedLoginService.login();
      return false;
    }
  }
}

@Injectable({
  providedIn: 'root',
})
class PermissionsService {
  authState: boolean = false;

  constructor() {}

  isAuthenticated(): boolean {
    const token = localStorage.getItem('access_token');
    return !!token;
  }
}
